
import httpRequest from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";

class CommunicationModuleService {
  constructor() { }

  // searchCommunicationMaster(searchParams) {
  //   let url =
  //     sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/CommunicationSearch";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: searchParams,
  //   });
  // }

  // getCommunicationModuleMasters() {
  //   let url =
  //     sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/GetCommunicationModuleMasters";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //   });
  // }

  // createNewUserLink(gernerateUserLink) {
  //   let url =
  //     sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/CreateNewUserLink";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: gernerateUserLink,
  //   });
  // }

  getCommunicationMasterById(para) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/GetCommunicationMasterById";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      params: para,
    });
  }
  getCommunicationDocuments(commMasterId, linkRefId) {
    let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/GetCommMasterDocuments";
    return httpRequest({
      url: url,
      method: "POST",
      // dataType: 'json',
      params: { commMasterId: commMasterId, linkRefId: linkRefId },
    });
  }
  saveCommMasterDocuments(saveDoc) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/SaveCommMasterDocuments";
    return httpRequest({
      url: url,
      method: "POST",
      data: saveDoc
    });
  }
  downloadFile(encryptedId, linkRefId) {
    let url = sharedGlobals.appUrls.miCustomerApiUrl + 'api/CommunicationModule/DownloadFile?commMasterId=' + encryptedId + '&linkRefId=' + linkRefId;
    window.open(url);
  }
  saveCommunicationLog(lpoCommunication) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/SaveCommunicationLog";
    return httpRequest({
      url: url,
      method: "POST",
      data: lpoCommunication,
    });
  }
  getCommunicationsLogsbyMasterId(commMasterId, linkrefId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/GetCommunicationsLogs";
    return httpRequest({
      url: url,
      method: "POST",
      params: { commMasterId: commMasterId, linkrefId: linkrefId },
    });
  }

  createOtpForCommunication(lpoCommunication) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/CreateOtpForCommunication";
    return httpRequest({
      url: url,
      method: "POST",
      data: lpoCommunication,
    });
  }
  validateOtpForCommunication(lpoCommunication) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/ValidateOtpForCommunication";
    return httpRequest({
      url: url,
      method: "POST",
      data: lpoCommunication,
    });
  }
  saveCommunicationMaster(lpoCommunication) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/SaveCommunicationMaster";
    return httpRequest({
      url: url,
      method: "POST",
      data: lpoCommunication,
    });
  }
  getCommunicationMasterForUserEntry(para) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/GetCommunicationMasterForUserEntry";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      params: para,
    });
  }
  submitCommunicationMaster(para) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/SubmitCommunicationMaster";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      params: para,
    });
  }
  getCommunicationModuleMastersForUserEntry() {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/GetCommunicationModuleMastersForUserEntry";
    return httpRequest({
      url: url,
      method: "POST",
    });
  }

  onReOpenTask(para) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/ReopenCommunicationMaster";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      params: para,
    });
  }

  // Get Quote Online company website feature
  saveGetQuoteOnlineMaster(lpoCommunication) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/CommunicationModule/SaveGetQuoteOnlineMaster";
    return httpRequest({
      url: url,
      method: "POST",
      data: lpoCommunication,
    });
  }

}

let instance = new CommunicationModuleService();
export default instance;